/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FastPlayJackpotInfo } from './FastPlayJackpotInfo';
import {
    FastPlayJackpotInfoFromJSON,
    FastPlayJackpotInfoFromJSONTyped,
    FastPlayJackpotInfoToJSON,
} from './FastPlayJackpotInfo';
import type { FastPlayGame } from './FastPlayGame';
import {
    FastPlayGameFromJSON,
    FastPlayGameFromJSONTyped,
    FastPlayGameToJSON,
} from './FastPlayGame';

/**
 * 
 * @export
 * @interface FastPlayGameResponse
 */
export interface FastPlayGameResponse {
    /**
     * 
     * @type {FastPlayJackpotInfo}
     * @memberof FastPlayGameResponse
     */
    jackpot: FastPlayJackpotInfo;
    /**
     * 
     * @type {FastPlayGame}
     * @memberof FastPlayGameResponse
     */
    fastPlayGame: FastPlayGame;
}

/**
 * Check if a given object implements the FastPlayGameResponse interface.
 */
export function instanceOfFastPlayGameResponse(value: object): value is FastPlayGameResponse {
    if (!('jackpot' in value) || value['jackpot'] === undefined) return false;
    if (!('fastPlayGame' in value) || value['fastPlayGame'] === undefined) return false;
    return true;
}

export function FastPlayGameResponseFromJSON(json: any): FastPlayGameResponse {
    return FastPlayGameResponseFromJSONTyped(json, false);
}

export function FastPlayGameResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FastPlayGameResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'jackpot': FastPlayJackpotInfoFromJSON(json['jackpot']),
        'fastPlayGame': FastPlayGameFromJSON(json['fastPlayGame']),
    };
}

export function FastPlayGameResponseToJSON(value?: FastPlayGameResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'jackpot': FastPlayJackpotInfoToJSON(value['jackpot']),
        'fastPlayGame': FastPlayGameToJSON(value['fastPlayGame']),
    };
}

